import React from 'react';
import NotFound from '@/assets/not_found.png';

function Page404() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <img style={{ width: '124px' }} src={NotFound} alt="" />
      <span
        style={{
          fontFamily: 'Roboto Regular',
          fontSize: '12px',
          color: '#505050',
          marginTop: '12px',
        }}
      >
        Halaman tidak ditemukan
      </span>
    </div>
  );
}

export default Page404;
